import React, { useEffect } from "react";
import InvitationLinkCopyButton from "../InvitationLinkCopyButton";
import "../EditInvite/EditInvite.css";
export default function InvitationShareNotice({docID,invitationLinkVersion,addAlertText,setShowShareLinkModal,showShareExplanation,setShowShareExplanation}) { useEffect(()=>{const close=(event)=>{if(event.key==="Escape")setShowShareLinkModal(false);};window.addEventListener("keydown",close);return()=>window.removeEventListener("keydown",close);},[setShowShareLinkModal]); return (<div
            className="share-link-modal-backdrop"
            onMouseDown={(event) => {
              if (event.target === event.currentTarget) setShowShareLinkModal(false);
            }}
          >
            <section
              className={`share-link-modal-box ${showShareExplanation ? "share-link-modal-box--expanded" : ""}`}
              role="dialog"
              aria-modal="true"
              aria-labelledby="share-link-modal-title"
            >
              <button
                type="button"
                className="share-link-modal-close"
                aria-label="סגירה"
                onClick={() => setShowShareLinkModal(false)}
              >
                ×
              </button>
              <p id="share-link-modal-title" className="share-link-modal-title">
                <strong>במידה ותרצו לשלוח <em>בעצמכם</em> את הלינק בוואטסאפ,</strong>
                <br />
                <strong>יש להעתיק לינק חדש לשליחה לאורחים</strong>
              </p>
              <p className="share-link-modal-reassurance">* חשוב לציין שגם הלינקים הישנים עדיין יעבדו!</p>
              <InvitationLinkCopyButton
                addAlertText={addAlertText}
                docID={docID}
                version={invitationLinkVersion}
                className="share-link-modal-copy"
              />
              <p className="share-link-modal-copy-note">ניתן להעתיק את הלינק גם מאוחר יותר בתפריט "אישורים"</p>
              {showShareExplanation && (
                <p className="share-link-modal-explanation">
                  כאשר משתפים לינק בוואטסאפ בפעם הראשונה, וואטסאפ קוראת את התמונה והכיתוב שבתוך הלינק. כאשר משתפים את הלינק שוב, וואטסאפ לא קוראת את הכל מחדש, אלא משתמשת בזיכרון דפדפן שיש לה כבר. לכן אם תשתפו את אותו לינק בדיוק עם השינויים שביצעתם כרגע, ווטאסאפ לא תשנה את התמונה/כותרת בתצוגה המקדימה. לכן יש לקבל לינק חדש, שהוא בעצם אותו דבר כמו הקודם, אבל טיפה שונה. חשוב לציין שכל הלינקים שתקבלו מהמערכת יעבדו תמיד, <span className="share-link-modal-explanation-highlight">ההבדל הוא רק בתצוגה המקדימה שוואטסאפ מראה</span> כשמשתפים את הלינק באופן עצמאי בעצמכם בוואטסאפ.
                </p>
              )}
              <button
                type="button"
                className="share-link-modal-explain"
                aria-expanded={showShareExplanation}
                onClick={() => setShowShareExplanation((current) => !current)}
              >
                הסבר
              </button>
            </section>
          </div>); }
